<template>
  <v-client-table
    :data="domains"
    :columns="columns"
    :options="options"
    class="domains-table"
    @row-click="onRowClick($event)"
  >
    <template slot="selected" slot-scope="props">
      {{ props.row.selected ? 'Yes' : 'No' }}
    </template>

    <template slot="verified" slot-scope="props">
      {{ props.row.verified ? 'Yes' : 'No' }}
    </template>

    <template slot="actions" slot-scope="props">
      <div class="d-flex justify-content-end">
        <verify-email-domain-button
          v-if="!props.row.verified"
          :domain="props.row"
          :profile-locked="profileLocked"
          :profile-approved="profileApproved"
          class="mx-2"
          @refresh-domain="$emit('refresh-domain', $event)"
          :disabled="!props.row.can_modify"
        ></verify-email-domain-button>

        <select-email-domain-button
          v-if="props.row.verified && !props.row.selected"
          :domain="props.row"
          class="mx-2"
          @refresh-domains="$emit('refresh-domains')"
          :disabled="!props.row.can_modify"
        ></select-email-domain-button>

        <delete-email-domain-button
            :domain="props.row"
            :profile-locked="profileLocked"
            :profile-approved="profileApproved"
            class="mx-2"
            :disabled="!canDeleteDomain(props.row)"
            :show-tooltip="props.row.can_modify"
        ></delete-email-domain-button>
      </div>
    </template>
  </v-client-table>
</template>

<script>
import columnTemplates from '../../../mixins/tables/columnTemplates';
import DeleteEmailDomainButton from './DeleteEmailDomainButton';
import SelectEmailDomainButton from './SelectEmailDomainButton';
import VerifyEmailDomainButton from './VerifyEmailDomainButton';

export default {
  name: 'email-domains-table',
  components: {DeleteEmailDomainButton, SelectEmailDomainButton, VerifyEmailDomainButton},
  mixins: [columnTemplates],
  props: {
    domains: {
      type: Array,
      required: true,
    },
    timezone: {
      type: String,
      required: true,
    },
    profileLocked: {
      type: Boolean,
      required: true,
      default: false,
    },
    profileApproved: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      columns: ['name', 'selected', 'verified', 'created_at', 'actions'],
    };
  },
  computed: {
    options() {
      return {
        columnsClasses: this.columns.reduce((classesMap, column) => ((classesMap[column] = column), classesMap), {}),
        dateColumns: ['created_at'],
        filterable: false,
        headings: {
          name: 'Domain',
          selected: 'Selected',
          verified: 'Verified',
          created_at: 'Created',
          actions: 'Actions',
        },
        sortable: ['name', 'selected', 'verified', 'created_at'],
        templates: this.columnTemplates(this.timezone),
      };
    },
  },
  methods: {
    onRowClick(event) {
      const {tagName} = (event && event.event && event.event.target) || {};
      if (tagName && tagName.toLowerCase() === 'td' && event.row.can_modify) {
        this.$emit('show-dns', event.row);
      }
    },
    canDeleteDomain(domain) {

      let five_minutes_in_the_past = moment(new Date()).tz('America/New_York').subtract(5, "minutes").format('YYYY-MM-DD HH:mm:ss');

      let dateA = new Date(five_minutes_in_the_past);
      let dateB = new Date(domain.created_at);

      if (!domain.can_modify) {
        return false;
      }

      return (dateA.getTime() > dateB.getTime()) && !this.profileLocked;
    }
  },
};
</script>

<style lang="scss">
.domains-table .actions {
  width: 1%;
}
</style>
